// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active,\n.fade-leave-active {\n  transition: 0.5s;\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}\n.routerView {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  overflow-y: scroll;\n}\n.maintenance_logo {\n  margin-top: 50px;\n  max-width: 150px;\n  opacity: 0.5;\n}\n.center a {\n  color: rgb(127, 255, 255);\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
